import { TagColor } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import { apiClient } from 'modules/core/lib/mobx-rest'

import IntegrationCodes from 'modules/marketplace/lib/integrationCodes'

export enum Status {
  NotAvailable = 'not_available',
  NotAuthenticated = 'not_authenticated',
  Authenticated = 'authenticated',
}

interface StatusResponse {
  status: Status
  refresh_token_expires_at: string
}

export const loginPath = () => `/integrations/${IntegrationCodes.datev_lauds_factorial}/oauth/login`

interface Data {
  companyId: number | undefined
  tenantId?: string | undefined
  clientId?: string | undefined
  organizationalUnitId?: string | undefined
}
type Responses = Record<string, StatusResponse>
class OauthService {
  private responses: Responses = {}

  statusLabel = () => {
    return {
      not_authenticated: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.status.not_linked.label'
      ),
      authenticated: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.status.linked.label'
      ),
      not_available: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.status.error.label'
      ),
    }
  }

  statusDescription = () => {
    return {
      not_authenticated: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.status.not_linked.description'
      ),
      authenticated: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.status.linked.description'
      ),
      not_available: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.status.error.description'
      ),
    }
  }

  statusToTagColor = () => {
    return {
      not_authenticated: TagColor.champagne,
      authenticated: TagColor.viridian,
      not_available: TagColor.radical,
    }
  }

  async getStatus(data: Data, bookkeeper_view: boolean) {
    const response = await this.getStatusResponse(data, bookkeeper_view)

    return response.status
  }

  async isNotAuthenticated(data: Data, bookkeeper_view: boolean) {
    const status = await this.getStatus(data, bookkeeper_view)

    return status === Status.NotAuthenticated
  }

  private async getStatusResponse(data: Data, bookkeeper_view: boolean) {
    const STATUS_PATH = `/integrations/${IntegrationCodes.datev_lauds_factorial}/oauth/status`
    const key = `${data.companyId}`

    const response = await apiClient().get(STATUS_PATH, {
      bookkeeper_view: bookkeeper_view,
      company_id: data.companyId,
    })
    this.responses[key] = response

    return response
  }
}
export default new OauthService()
